import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import CustomAgGrid from '../commoncomponents/CustomAgGrid';
import ContractManagementRepository from '../../api/repositories/contractManagementRepository';

const ContractHistory = () => {

    const location = useLocation();
    const [rows, setRows] = useState([]);
    const [gridAPI, setgridAPI] = useState({});


    const { serviceDesc: service, parentContractId: parentId } = location?.state || {};    

    const getContractHistoryRows = async (service, parentId) => {
        try {
            const response = await ContractManagementRepository.fetchContractHistory(parentId, service);
            setRows(response.map((item) => ({
                currContractNo: item.newContractno || "",
                prevContractNo: item.oldContractno || "",
                renewalDate: item.rewStartdate || "",
                contractType: item.contracttype || "",
                contractEndDate: item.enddate || "",
                contractStartDate: item.startdate || "",
                totalContractValue: item.totalcontractvalue || "",
                ...item
            }
            )));

        } catch (error) {
            console.error("Error fetching data", error);
        } finally {
            // setIsLoading(false);
        }
    };


    useEffect(() => {
        if(parentId){
            getContractHistoryRows(service, parentId);
        };
    }, [])

    const columns_Field = [
        {
            field: 'currContractNo',
            headerName: 'Current Contract Number',
            minWidth:200
        },
        {
            field: 'vendorCode',
            headerName: 'Vendor Code',
            minWidth:200

        },
        {
            field: 'vendorName',
            headerName: 'Vendor Name',
            minWidth:300

        },
        {
            field: 'prevContractNo',
            headerName: 'Previous Contract Number',
        },
        {
            field: 'renewalDate',
            headerName: 'Renewal Date',
        },
        {
            field: 'contractType',
            headerName: 'Contract Type',
        },

        {
            field: 'contractStartDate',
            headerName: 'Contract Start Date',
        },
        {
            field: 'contractEndDate',
            headerName: 'Contract End Date',
        },
        {
            field: 'totalContractValue',
            headerName: 'Total Conrtact Value',
        }
    ];

    return (
        <>
            <CustomAgGrid
                refSet={gridAPI}
                rows={rows}
                columns={columns_Field}
                setGridApi={setgridAPI}
            />
        </>
    );

}

export default ContractHistory;